export type AccountStatus = 'active' | 'banned' | 'suspended' | 'deleted' | 'locked';

export interface AuthErrorDetails {
  reason?: AccountStatus;
  until?: string; // ISO date string
  contact?: string;
  requiresAction?: 'verify_email' | 'verify_phone' | 'reset_password';
}

export interface AuthError {
  code: string;
  message: string;
  status?: number;
  details?: AuthErrorDetails;
}

export interface ZombieSessionConfig {
  maxRetries?: number;
  retryDelay?: number;
  aggressiveCleanup?: boolean;
  onZombieDetected?: () => void;
  onSessionCleared?: () => void;
  onBanDetected?: (details: AuthErrorDetails) => void;
}

// Common Supabase auth error patterns
export const AUTH_ERROR_PATTERNS = {
  BANNED: /banned|blocked|suspended|prohibited/i,
  INVALID_CREDENTIALS: /invalid.*credentials|wrong.*password/i,
  EMAIL_NOT_VERIFIED: /email.*not.*confirmed|verify.*email/i,
  RATE_LIMITED: /rate.*limit|too.*many.*requests/i,
  SESSION_EXPIRED: /session.*expired|token.*expired/i,
  NETWORK_ERROR: /network|connection|offline/i,
} as const;

// User-friendly error messages
export const AUTH_ERROR_MESSAGES: Record<string, string> = {
  banned: "Your account has been suspended. Please contact support for assistance.",
  suspended: "Your account is temporarily suspended. Please try again later.",
  deleted: "This account no longer exists.",
  locked: "Your account has been locked for security reasons. Please reset your password.",
  email_not_verified: "Please verify your email address before logging in.",
  rate_limited: "Too many login attempts. Please wait a few minutes before trying again.",
  session_expired: "Your session has expired. Please log in again.",
  network_error: "Connection error. Please check your internet connection.",
  unknown: "An unexpected error occurred. Please try again.",
};